import React, { PropsWithChildren } from 'react';

import styled from 'styled-components';

import { disclaimerTypes } from 'utils/constants';

const Disclaimer = styled.div`
  ol {
    counter-reset: item;
    font-family: ${(props) => props.theme.fonts.default};
    list-style: none;
    margin-bottom: 0;
    padding-left: 0;

    li {
      color: ${(props) => props.theme.colors.lightGray};
      counter-increment: item;
      font-size: 0.75rem;
      margin-bottom: 1rem;

      @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
        font-size: 0.875rem;
      }

      &:before {
        color: ${(props) => props.theme.colors.primaryRed};
        content: counter(item);
        margin-right: 0.3125rem;
      }
    }
  }
`;

const Footnotes = styled.div`
  margin-bottom: 5rem;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.lg}) {
    margin-bottom: 4.75rem;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin-bottom: 3.25rem;
  }
`;

interface DisclaimerTagProps {
  type: string;
}

const DisclaimerTag: React.FC<PropsWithChildren<DisclaimerTagProps>> = ({ type, children }) => {
  if (type === disclaimerTypes.DISCLAIMER) {
    return <Disclaimer>{children}</Disclaimer>;
  } else if (type === disclaimerTypes.FOOTNOTE) {
    return <Footnotes>{children}</Footnotes>;
  } else {
    return <>{children}</>;
  }
};

export default React.memo(DisclaimerTag);
